export const darkTheme = {
    bg:"#0A1628",
    bgLight: "#132337",
    primary:"#FDB813",
    text_primary:"#F5F5F5",
    text_secondary:"#B8C5D6",
    card:"#1A2332",
    card_light: '#1E2A3A',
    button:"#FDB813",
    white:"#FFFFFF",
    black:"#000000",
    accent:"#3B82F6",
    accent_light:"#60A5FA",
}

export const lightTheme = {
    bg:"#F8FAFC",
    bgLight: "#F1F5F9",
    primary:"#2563EB",
    text_primary:"#1E293B",
    text_secondary:"#475569",
    card:"#FFFFFF",
    button:"#2563EB",
    accent:"#F59E0B",
    accent_light:"#FCD34D",
}